// removed by extract-text-webpack-plugin
module.exports = {"narrowMax":"1000","wideMax":"Infinity","narrow":"narrow","wide":"wide"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app.scss
// module id = xZZD
// module chunks = 6